import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerInfo {
    name: string;
    email: string;
    address: {
        line1: string;
        line2?: string;
        city: string;
        state: string;
        postal_code: string;
        country: string;
    };
}

interface CheckoutState {
    quantity: number;
    basePrice: number;
    customerInfo: CustomerInfo | null;
    orderId: string | null;
    orderStatus: 'pending' | 'processing' | 'completed' | 'failed' | null;
}

const initialState: CheckoutState = {
    quantity: 50, // Default quantity
    basePrice: 1.50, // Price per napkin
    customerInfo: null,
    orderId: null,
    orderStatus: null,
};

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        setQuantity(state, action: PayloadAction<number>) {
            state.quantity = action.payload;
        },
        setCustomerInfo(state, action: PayloadAction<CustomerInfo>) {
            state.customerInfo = action.payload;
        },
        setOrderId(state, action: PayloadAction<string>) {
            state.orderId = action.payload;
        },
        setOrderStatus(
            state,
            action: PayloadAction<'pending' | 'processing' | 'completed' | 'failed'>
        ) {
            state.orderStatus = action.payload;
        },
        resetCheckout(state) {
            state.customerInfo = null;
            state.orderId = null;
            state.orderStatus = null;
        },
    },
});

export const {
    setQuantity,
    setCustomerInfo,
    setOrderId,
    setOrderStatus,
    resetCheckout,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
